import * as React from "react";
import Svg, { Path } from "react-native-svg";

function WhatsappSmall(props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M8.002 0h-.004C3.587 0 0 3.588 0 8a7.94 7.94 0 001.523 4.689l-.997 2.972 3.075-.983A7.93 7.93 0 008.002 16C12.413 16 16 12.411 16 8s-3.587-8-7.998-8z"
        fill="#54C824"
      />
      <Path
        d="M12.657 11.296c-.193.545-.959.997-1.57 1.129-.418.089-.964.16-2.802-.602-2.35-.974-3.865-3.363-3.983-3.518-.113-.155-.95-1.265-.95-2.413s.583-1.707.818-1.947c.193-.197.512-.287.818-.287.1 0 .188.005.268.009.235.01.353.024.508.395.193.465.663 1.613.72 1.73.056.119.113.279.033.434-.075.16-.14.23-.259.367-.118.136-.23.24-.348.386-.108.127-.23.263-.094.498.136.23.606.997 1.298 1.613.893.795 1.617 1.049 1.876 1.157.193.08.423.06.564-.09.18-.192.4-.512.625-.827.16-.226.362-.254.574-.174.216.075 1.36.64 1.594.757.235.118.39.174.447.273.056.099.056.564-.137 1.11z"
        fill="#fff"
      />
    </Svg>
  );
}

export default WhatsappSmall;
